import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=183e1ea5&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"
import style0 from "./publish.vue?vue&type=style&index=0&id=183e1ea5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e1ea5",
  null
  
)

export default component.exports